// extracted by mini-css-extract-plugin
module.exports = {"container":"Message_container__1AicE","page":"Message_page__2na8a","content":"Message_content__2D9uO"};